import { css } from 'styled-components'

export default css`
  .BaseModal-Content.popup {
    width: 520px;
    overflow: visible;
  }

  &.EditPhoneModal .BaseModal-Body {
    position: relative;
    overflow: visible;
    padding: 60px;
  }

  .edit-phone-decorative-image {
    position: absolute;
    top: 0;
    right: 0;
    pointer-events: none;
  }

  .edit-phone-form {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .edit-phone-title {
    font-size: 32px;
    line-height: 36px;
    font-family: 'Rubik-Regular', sans-serif;
  }

  .edit-phone-subtitle {
    font-size: 16px;
    line-height: 20px;
  }

  .edit-phone-input-row {
    display: flex;
    gap: 10px;
    align-items: flex-start;
  }

  .edit-phone-label {
    font-size: 14px;
    line-height: 18px;
    color: #6b7280;
    margin-bottom: 8px;
  }

  .edit-phone-actions {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }
`
